import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import HomeSeriesCard from "./HomeSeriesCard";
import { StoriesCard } from "./Updates";
import { FeaturedSeriesCard } from "./Leftsection";
import { Globals } from "./constants";
import axios from "axios";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import { Telco } from "./telco";

import {
  VideosListFourByThree,
  InHouseContent,
  Rankings,
  FullWidthCard,
  MobileFeaturedSeries,
} from "./HelperFunctions";

import { Helmet } from "react-helmet";

class Home extends Component {
  constructor(props) {
    super(props);

    var loadTime =
      window.performance.timing.domContentLoadedEventEnd -
      window.performance.timing.navigationStart;
    console.log(window.performance);
    console.log("HOME loadTIme " + loadTime);
    this.state = {
      seriesApiPath: Globals.ApiUrl + "api/v2/series/featured",
      seriesApiResp: [],
      homeApiResp: [],
      currentRankings: "odi",
      customCssTransition: "h-transition",
      isLoading: true,
      page: 1,
      pagesEnd: false,
      hasError: false,
      counter: 0,
    };

    this.isMobile = window.innerWidth < 992;
    this.rankingsChange = this.rankingsChange.bind(this);
    this.getMarkup = this.getMarkup.bind(this);
    this.getFromApi = this.getFromApi.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  async componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // let url = this.state.seriesApiPath,
    // resp;

    // try{
    //     resp = await axios.get(url)
    // }catch(error){
    //     console.log('error fetching series');
    // }

    // if(resp.status === 200){
    //     this.setState({seriesApiResp: resp.data.featured_series})
    //     console.log('series fetched', this.state.seriesApiResp);
    // }else{
    //     console.log('error fetching series!');
    // };

    await this.getFromApi();

    if (this.state.hasError) {
      console.log("Error : 1");
      await this.knockingNetWorking();
      await this.setState(() => {
        return { counter: this.state.counter + 1 };
      });
    }
  }

  //========================================================================
  knockingNetWorking = async () => {
    let cnt = 0;
    console.log("knock Called");
    for (let i = 0; i < 3; i++) {
      setTimeout(() => {
        this.getFromApi();
        console.log(
          "Home Main Contents.....!",
          i,
          this.state.isLoading,
          this.state.hasError,
          this.state.counter
        );
        cnt = cnt + 1;
        this.setState(() => {
          return { counter: cnt };
        });
      }, 15000);

      if (this.state.isLoaded) return;
    }
  };

  //==================================End========================================

  refresh() {
    this.setState(
      { isLoading: true, hasError: false, customCssTransition: "h-transition" },
      this.getFromApi
    );
  }

  async getFromApi() {
    let homeApiResp,
      homeApiUrl =
        Globals.ApiUrl +
        "api/v3/view_lists/get_by_name?view=home&web_user=1&page=1&telco=" +
        this.props.telco +
        "&app_name=" +
        Globals.appName;

    try {
      homeApiResp = await axios.get(homeApiUrl);
      this.setState(() => {
        return {
          isLoading: true,
          hasError: false,
          customCssTransition: "h-transition",
        };
      });

      console.log("Home Api Response", homeApiResp);
    } catch (err) {
      console.log("Error fetching Home Api", err);
      // this.setState({hasError: true, customCssTransition: 'v-transition', isLoading: false})
    }

    homeApiResp && homeApiResp.status === 200 && Array.isArray(homeApiResp.data)
      ? this.setState({
          homeApiResp: homeApiResp.data,
          customCssTransition: "v-transition",
          isLoading: false,
        }) //hide loader after set state
      : this.setState({
          hasError: true,
          customCssTransition: "v-transition",
          isLoading: false,
        });
  }

  rankingsChange(e) {
    if (e.target.id !== this.state.currentRankings)
      this.setState({ currentRankings: e.target.id });
  }

  async nextPage(e) {
    if (!this.state.pagesEnd) {
      let elem = document.getElementsByClassName("loading-more-results");
      if (elem.length) elem[0].classList.remove("d-none");

      const page = this.state.page + 1;
      const url =
        Globals.ApiUrl +
        "api/v3/view_lists/get_by_name?view=home&web_user=1&page=" +
        page.toString() +
        "&telco=" +
        this.props.telco +
        "&app_name=" +
        Globals.appName;
      let resp;
      try {
        resp = await axios.get(url);
        console.log("Next page", resp);
      } catch (err) {
        console.log("error fetching next page");
      }

      if (resp.status === 200 && resp.data.length > 0) {
        if (elem.length) elem[0].classList.add("d-none");

        const homeApiResp = this.state.homeApiResp.concat(resp.data);

        this.setState({ page: page, homeApiResp: homeApiResp }, () =>
          console.log("Next page state set", this.state)
        );
      } else {
        if (elem.length) elem[0].classList.add("d-none");

        if (resp.data.length === 0) this.setState({ pagesEnd: true });

        console.log("Api Error or no results");
      }
    }
  }

  getMarkup() {
    return this.state.homeApiResp.map((categoryList, i) => {
      switch (categoryList.type) {
        case "series":
          return (
            <HomeSeriesCard
              key={"hms-" + i}
              image={this.bgImage}
              islive={true}
              data={categoryList}
            />
          );
        case "in_house_content":
          return <InHouseContent key={"inhouse-" + i} data={categoryList} />;
        case "ranking":
          return (
            <Rankings
              key={"rankings-" + i}
              data={categoryList}
              currentRankings={this.state.currentRankings}
              rankingsChange={this.rankingsChange}
            />
          );
        case "generic-home":
          return (
            <div key={"generic-section-" + i} className="card mb-2 p-3">
              <FullWidthCard
                type={categoryList.type}
                subType={categoryList.sub_type}
                data={categoryList.data[0]}
              />
            </div>
          );
        case "video":
          return (
            <VideosListFourByThree key={"vids-" + i} data={categoryList} />
          );
        default:
          console.log("Other type occured in home lists", categoryList);
      }
    });
  }

  render() {
    return (
      <section
        id="main-section"
        className="px-lg-0 jc-inner-page  align-self-start"
      >

        <div className={this.state.customCssTransition}>
          <div className="card p-3 mb-2">
          <HomeNav path={this.props.match}></HomeNav>
          </div>
          
          {/*{
            
            (this.state.hasError && this.state.counter > 2) ?
            <div className="has-error card min-height-80vh p-3">
              <h5> Error or no result <button className="btn btn-default" onClick={this.refresh}>Try Again</button></h5>
            </div> : 
              this.getMarkup()
          }

          {
            (!this.state.pagesEnd && this.state.homeApiResp.length) ?
            (
              <div>
                <div className="text-center d-none loading-more-results"><img src="/images/loader_v2.gif" height="30" alt="" /></div>
                <button id="more-results" onClick={this.nextPage} type="button" className="btn btn-primary d-none">More Results</button>
              </div>
            )
            : <div></div>
          }*/}

        </div>


        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Live Cricket Streaming, Match Highlights{" "}
            {Globals.product === "Cricwick"
              ? ", News & Fantasy league"
              : "& News"}{" "}
            | {Globals.product}
          </title>
          <meta
            name="description"
            content={
              "Watch Live Cricket Streaming & Match Highlights, Get the Latest News " +
                Globals.product ===
              "Cricwick"
                ? "and win cash prizes with Fantasy League only on "
                : "only on " + Globals.product
            }
          />
          <link
            rel="canonical"
            href={window.location.href.replace("www.", "")}
          />
        </Helmet>
        {this.state.isLoading ? (
          <div className="main-loader card min-height-80vh">
            <img width="64" height="64" src="/images/loader_v2.gif" alt="" />
          </div>
        ) : (
          <div />
        )}

        <div className={this.state.customCssTransition}>
          {this.state.hasError && this.state.counter > 2 ? (
            <div className="has-error card min-height-80vh p-3">
              <h5>
                {" "}
                Error or no result{" "}
                <button className="btn btn-default" onClick={this.refresh}>
                  Try Again
                </button>
              </h5>
            </div>
          ) : (
            this.getMarkup()
          )}

          {!this.state.pagesEnd && this.state.homeApiResp.length ? (
            <div>
              <div className="text-center d-none loading-more-results">
                <img src="/images/loader_v2.gif" height="30" alt="" />
              </div>
              <button
                id="more-results"
                onClick={this.nextPage}
                type="button"
                className="btn btn-primary d-none"
              >
                More Results
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>
      </section>
    );
  }
}

export const HomeNav = (props) => (
  <div className="d-flex overflow-x-auto">
      <Link to={"/"}>
          <h4 className={MatchNavActiveClasses(props, "/")}>Home</h4>
      </Link>
      {
        // (props.data && props.data[0] && props.data[0].series_obj.is_videos_enabled) ? 
        // ( 
          
        <Link to={"/videos"}>
          <h4 className={MatchNavActiveClasses(props, "/videos", "/videos", "/videos")+' ml-4'}>Videos</h4>
         </Link>
        // ):
        // (<div></div>)
      }

      {
        // (props.dara && props.data[0] && props.data[0].series_obj.has_points_table) ? 
        // ( 
          <Link to={"/mystars"}>
              <h4 className={MatchNavActiveClasses(props, "/mystars")+' ml-4 text-danger'}>MyStars11</h4>
          </Link>
        // ):
        // (<div></div>)
      }

      {
        // (props.dara && props.data[0] && props.data[0].series_obj.has_points_table) ? 
        // ( 
          <Link to={"/rankings"}>
              <h4 className={MatchNavActiveClasses(props, "/mystars")+' ml-4'}>Rankings</h4>
          </Link>
        // ):
        // (<div></div>)
      }

      
  </div>
);

const MatchNavActiveClasses = (props, path, otherPath) => {
  let str = "";
  console.log("path is: " + path);
  //console.log("props path is: " + props.path.path);
  (props.path === path || props.path === otherPath) ? 
  (str = "font-weight-semi-bold p-2  m-f-14  border-bottom border-danger") : 
  (str = "font-weight-semi-bold p-2  m-f-14");
  return str;
};

export default Home;
